import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { eAccountType, eCreativeStatus, eCreativeStatusBuild } from '@Workspace/_generated/enums';
import { ICreativeDto, IBaseCampaignDto, IUserPropertiesDto } from '@Workspace/_generated/interfaces';
import { AuthService } from '@Workspace/auth';

@Component({
    selector: 'creative-status-indicator',
    templateUrl: './creative-status-indicator.component.html',
    styleUrls: ['./creative-status-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreativeStatusIndicatorComponent implements OnInit {

    constructor(private authService: AuthService) {}

    @Input() creativeStatusId: eCreativeStatus;
    @Input() campaignType: eAccountType;
    @Input() creativeBulidStatusId: eCreativeStatusBuild;
    eCreativeStatus = eCreativeStatus;
    eAccountType = eAccountType;
    currentUser: IUserPropertiesDto = this.authService.userSettings;

    ngOnInit(): void {
    } 

    // Method to get flight creative build status
    getFlightCreativeBuildStatus(): string | null {
        if(this.currentUser?.permissions?.isHMPClient || this.currentUser?.permissions?.isHSClient)
            return null;

        if (this.creativeBulidStatusId === eCreativeStatusBuild.Build_Failed) 
            return 'Build Failed';        

        if (this.creativeBulidStatusId === eCreativeStatusBuild.Build_Partial_Success) 
            return 'Partial Success';

        if (this.creativeBulidStatusId === eCreativeStatusBuild.Send_to_API) 
            return 'Sent to API';

        if (this.creativeBulidStatusId === eCreativeStatusBuild.Build_Success) 
            return 'Build Success';

        if (this.creativeBulidStatusId === eCreativeStatusBuild.Notset) 
            return null;

        return null;
    }
}
